/**
 * @desc 列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.LogisticsAttrTypeModel>>;
export function request(
  body: defs.basics.LogisticsAttrTypeRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/logisticsAttrType/list`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
